import {
  BubbleMetadata,
  ClusterMetadata,
  HeaderMetadata,
} from '@/components/public/Visualisations/BubblesV2/Metadata'
import { Path } from '@/types'

export class BubblesMetadataRegister {
  private _bubbles: Record<string, BubbleMetadata> = {}
  private _clusters: Record<string, ClusterMetadata> = {}
  private _headers: Record<string, HeaderMetadata> = {}

  reset() {
    this._bubbles = {}
    this._clusters = {}
    this._headers = {}
  }

  addBubble(bubble: BubbleMetadata) {
    this._bubbles[bubble.path.toString()] = bubble
  }

  addCluster(cluster: ClusterMetadata) {
    this._clusters[cluster.path.toString()] = cluster
  }

  addHeader(header: HeaderMetadata) {
    this._headers[header.path.toString()] = header
  }

  removeBubble(path: Path | string) {
    delete this._bubbles[path.toString()]
  }

  removeCluster(path: Path | string) {
    delete this._clusters[path.toString()]
  }

  removeHeader(path: Path | string) {
    delete this._headers[path.toString()]
  }

  getBubble(path: Path | string): BubbleMetadata {
    return this._bubbles[path.toString()]
  }

  getCluster(path: Path | string): ClusterMetadata {
    return this._clusters[path.toString()]
  }

  getHeader(path: Path | string): HeaderMetadata {
    return this._headers[path.toString()]
  }

  get bubbles(): BubbleMetadata[] {
    return Object.values(this._bubbles)
  }

  get clusters(): ClusterMetadata[] {
    return Object.values(this._clusters)
  }

  get headers(): HeaderMetadata[] {
    return Object.values(this._headers)
  }
}
